import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from 'react-router-dom';

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

import TableContainerV1 from '../../../components/Common/TableContainerV1';
import { getApiConfiguration} from 'helpers/UAM/apiConfig.helper'


const ApiConfiguration = props => {

  //meta title
  document.title = "API Configuration | DMS";
  const navigate = useNavigate();
  const { roleName } = JSON.parse(localStorage.getItem("user"))
  const [apiConfigList, setApiConfigList] = useState([]);
  const [pagination, setPagination] = useState({pageIndex:0,pageCount:0,totalRecords:0});
  const [pageNo,setPageNo]= useState(1);
  const [pageSize,setPageSize]= useState(10);
  const [searchValue,setSearchValue]= useState("");
  const [columnId,setColumnId]= useState("id");
  const [sortingOrderStatus,setSortingOrderStatus]= useState("desc");


  const navigateToeEditApiConfiguration = (id) => {
    const encryptedId = btoa(id.toString()); 
      navigate(`/${roleName}/api-config/edit?id=${encodeURIComponent(encryptedId)}`) 
  }; 

  const navigateToeViewApiConfiguration = (id) => {
    const encryptedId = btoa(id.toString()); 
      navigate(`/${roleName}/api-config/view?id=${encodeURIComponent(encryptedId)}`) 
  }; 
  const [sortingOptions, setSortingOptions] = useState({ column:'id',isAsc:false,optionalColumn:['Action']})

  // Customber Column
  const columns = useMemo(
    () => [
        {
            Header: 'Id',
            accessor: 'id',
            filterable: true,
            Cell: (cell) => {
              return cell.value ? cell.value : '';
            }
        },
      {
        Header: 'URL',
        accessor: 'url',
        filterable: true,
        Cell: (cell) => {
          return cell.value ? cell.value : '';
        }
      },
      {
        Header: 'Purpose',
        accessor: 'purpose',
        filterable: true,
        Cell: (cell) => {
          return cell.value ? cell.value : '';
        }
      },
      {
        Header: 'Action',
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-horizontal font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
              <DropdownItem
                  onClick={() => {
                    navigateToeViewApiConfiguration(rowData.id);
                  }
                  }
                >
                  <i className="mdi mdi-eye font-size-16 text-success me-1" id="viewtooltip"></i>
                  View
                  <UncontrolledTooltip placement="top" target="viewtooltip">
                    View
                  </UncontrolledTooltip>
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    navigateToeEditApiConfiguration(rowData.id);
                  }
                  }
                >
                  <i className="mdi mdi-pencil font-size-16 text-success me-1" id="edittooltip"></i>
                  Edit
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Edit
                  </UncontrolledTooltip>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        }
      },
    ],
    []
  );

  const getApiConfigurationList = async () => {
    const body = {
      page:pageNo,
      limit:pageSize,
      searchKey:searchValue,
      columnName:columnId,
      sortingOrder:sortingOrderStatus
    }
    const apiRes = await getApiConfiguration(body);
    if (apiRes.status) {
      setApiConfigList(apiRes.data.data);
      const {totalItems,totalPages,currentPage}  = apiRes.data
      setPagination({pageIndex:currentPage,pageCount:totalPages,totalRecords:totalItems})
    }else{
      setPagination({ pageIndex: 0, pageCount: 0, totalRecords: 0 })
      setApiConfigList([])
    }
  };


  useEffect(() => {
    getApiConfigurationList();
  },[searchValue, pageNo, pageSize, columnId, sortingOrderStatus]);

  const handleCustomerClicks = () => {
    navigate(`/${roleName}/api-config/add`)
  };

  const handlePageChange = (page,pageSize,search=searchValue,columnName=columnId, sortingOrder = sortingOrderStatus) =>{
    setPageNo(page);
    setPageSize(pageSize);
 }

 const handleSortColumn = (option) =>{
   setSortingOptions(option)
   const columnName=option.column;
   setColumnId(columnName)
   const sortingOrder = option.isAsc ? "asc" : "desc";
   setSortingOrderStatus(sortingOrder)
   handlePageChange(1,pageSize,searchValue,columnName,sortingOrder)
 }

 const handleSearchFilter = (value,pageSize) => {
   setSearchValue(value)
   handlePageChange(1,pageSize,value);
 }
 const handleClearSearch = () =>{
   setSearchValue("")
   handlePageChange(1,pageSize,"","id","desc")
 }
 const buttonSection = (
  <div className="text-sm-end">
     <Button
       type="button"
       color="success"
       className="btn-rounded mb-2 me-2"
       onClick={handleCustomerClicks}
     >
       <i className="mdi mdi-plus me-1" />
       New API Configuration
     </Button>
   </div>);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Configuration" breadcrumbItem="Api Configurations" />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                   <TableContainerV1
                    columns={columns}
                    data={apiConfigList}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handleSearchFilter={handleSearchFilter}
                    customSection={buttonSection}
                    searchHelperText="Search by URL and Purpose"
                    sortOptions={sortingOptions}
                    handleSortColumn={handleSortColumn}
                    handleClearSearch={handleClearSearch}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ApiConfiguration;